import * as Yup from 'yup'

export const agentValidationRules = Yup.object().shape({
  members: Yup.array().required('agent(s) required').nullable(),
});